import { div, img, span, udex } from '../../../scripts/dom-builder.js';
import { infoTypes } from '../constants.js';

function showAvatar(author) {
  return (
    author &&
    author.image &&
    author.image !== '0' &&
    new URL(author.image).pathname !== '/default-meta-image.png' &&
    author.name.indexOf('+ more') === -1
  );
}

function getAvatar(author) {
  return udex(
    'avatar',
    {
      size: 'XS',
      shape: 'circle',
    },
    img({
      src: author.image,
      alt: 'Author avatar',
    }),
  );
}

export default function getAvatarElement(author, infoOption) {
  if (!author) {
    return div();
  }

  const name = span();
  const container = div({ class: 'author subtitle' }, name);

  (async () => {
    const entry = await author;
    if (entry) {
      name.textContent = entry.name;
      if (showAvatar(entry) && infoOption === infoTypes.AUTHOR) {
        const avatar = getAvatar(entry);
        const authorProfile = div(
          { class: 'author-profile' },
          avatar,
          div(
            { class: 'avatar-info' },
            div({ class: 'name' }, div(entry.name)),
            entry.description && entry.description !== '0'
              ? div({ class: 'description info' }, div(entry.description))
              : '',
          ),
        );
        container.replaceWith(authorProfile);
      }
    }
  })();

  return container;
}
